export const translations = {
  pt: {
    nav: {
      about: "Sobre",
      experience: "Experiência",
      certifications: "Certificações",
      projects: "Projetos",
      skills: "Habilidades",
      contact: "Contato",
    },
    hero: {
      badge: "UX Writer & Designer Conversacional",
      name: "Paulo da Silva Pascoa Junior",
      title: "Especializado em Chatbots, IA Generativa e Experiência do Usuário",
      description: "Transformo interações frustrantes em jornadas encantadoras através do design conversacional e UX Writing estratégico.",
      cta: "Entre em Contato",
      viewProjects: "Ver Projetos",
    },
    about: {
      title: "Especialidades",
      subtitle: "Crio experiências digitais humanizadas",
      specialties: {
        conversational: {
          title: "Design Conversacional",
          description: "Desenvolvo diálogos naturais para chatbots e assistentes virtuais.",
        },
        uxWriting: {
          title: "UX Writing",
          description: "Crio microcopy que guia usuários e reduz atritos.",
        },
        ai: {
          title: "IA Generativa",
          description: "Desenvolvo prompts personalizados para respostas empáticas.",
        },
      },
    },
    experience: {
      title: "Experiência",
      subtitle: "Minha jornada profissional",
      jobs: [
        {
          period: "Set 2024 → Out 2024",
          company: "Ozia",
          role: "Designer Conversacional",
          achievements: [
            "Criação e manutenção de chatbots",
            "Implementação de IA Generativa",
            "Testes A/B em instruções",
          ],
        },
        {
          period: "Nov 2022 → Mar 2023",
          company: "Sabion ~ Bradesco",
          role: "VUX Writer",
          achievements: [
            "Curadoria de fluxos URA",
            "Construção de tabelas NLP",
            "Interface de voz (VUI)",
          ],
        },
        {
          period: "Jul 2021 → Nov 2022",
          company: "Compasso UOL - TakeBlip",
          role: "UX Writer",
          achievements: [
            "Fluxos macro/micro de chatbots",
            "Curadoria de chatbots",
            "Testes A/B",
          ],
        },
      ],
    },
    certifications: {
      title: "Certificações",
      subtitle: "Formação contínua e especialização",
      viewCertificate: "Ver Certificado",
    },
    projects: {
      title: "Projetos",
      subtitle: "Cases de sucesso",
      detailedCases: "Cases Detalhados",
      otherProjects: "Outros Projetos",
      viewFullCase: "Ver Case Completo",
      legacy: {
        title: "GPT-4 em Chatbot",
        company: "Cliente Confidencial",
        role: "Designer Conversacional",
        description: "Implementação de OpenAI GPT-4 em chatbot de suporte.",
      },
    },
    skills: {
      title: "Habilidades",
      subtitle: "Competências técnicas",
      categories: {
        tools: "Ferramentas",
        conversational: "Design Conversacional",
        ai: "Inteligência Artificial & LLMs",
      },
      items: {
        dialogArchitecture: "Arquitetura de Diálogo",
        voiceTone: "Voz e Tom",
        promptEngineering: "Prompt Engineering",
        fineTuning: "Fine-tuning",
      },
    },
    contact: {
      title: "Contato",
      subtitle: "Vamos conversar",
      info: {
        email: "E-mail",
        phone: "Telefone",
        linkedin: "LinkedIn",
      },
      form: {
        title: "Envie uma mensagem",
        name: "Nome",
        email: "E-mail",
        subject: "Assunto",
        message: "Mensagem",
        namePlaceholder: "Seu nome",
        emailPlaceholder: "seu@email.com",
        subjectPlaceholder: "Assunto da mensagem",
        messagePlaceholder: "Sua mensagem...",
        send: "Enviar Mensagem",
        sending: "Enviando...",
        required: "*",
      },
      validation: {
        nameRequired: "Nome é obrigatório",
        nameTooLong: "Nome muito longo",
        emailInvalid: "E-mail inválido",
        emailTooLong: "E-mail muito longo",
        subjectRequired: "Assunto é obrigatório",
        subjectTooLong: "Assunto muito longo",
        messageRequired: "Mensagem deve ter pelo menos 10 caracteres",
        messageTooLong: "Mensagem muito longa",
      },
      toast: {
        validationError: "Erro de validação",
        validationDescription: "Por favor, corrija os erros no formulário.",
        success: "Mensagem enviada!",
        successDescription: "Obrigado pelo contato. Responderei em breve.",
        error: "Erro ao enviar",
        errorDescription: "Não foi possível enviar sua mensagem. Tente novamente.",
      },
    },
    caseDetail: {
      back: "Voltar",
      notFound: "Case não encontrado",
      backToHome: "Voltar para Home",
      viewFigma: "Ver no Figma",
      viewPrototype: "Ver Protótipo",
      challenge: "O Desafio",
      solution: "Minha Proposta",
      responsibilities: "Responsabilidades",
      tools: "Ferramentas",
      projectEvolution: "Evolução do Projeto",
      results: "Resultados",
      keyLearning: "Principal Aprendizado",
      cta: {
        title: "Gostou deste projeto?",
        description: "Vamos conversar sobre como posso ajudar seu negócio.",
        button: "Entre em Contato",
      },
    },
    recommendations: {
      title: "Recomendações",
      subtitle: "O que dizem sobre meu trabalho",
      project: "Projeto"
    },
    footer: {
      name: "Paulo da Silva Pascoa Junior",
      subtitle: "UX Writer & Designer Conversacional",
      rights: "Todos os direitos reservados.",
    },
  },
  en: {
    nav: {
      about: "About",
      experience: "Experience",
      certifications: "Certifications",
      projects: "Projects",
      skills: "Skills",
      contact: "Contact",
    },
    hero: {
      badge: "UX Writer & Conversational Designer",
      name: "Paulo da Silva Pascoa Junior",
      title: "Specialized in Chatbots, Generative AI, and User Experience",
      description: "Transforming frustrating interactions into delightful journeys through conversational design and strategic UX Writing.",
      cta: "Get in Touch",
      viewProjects: "View Projects",
    },
    about: {
      title: "Specialties",
      subtitle: "Creating humanized digital experiences",
      specialties: {
        conversational: {
          title: "Conversational Design",
          description: "Developing natural dialogues for chatbots and virtual assistants.",
        },
        uxWriting: {
          title: "UX Writing",
          description: "Creating microcopy that guides users and reduces friction.",
        },
        ai: {
          title: "Generative AI",
          description: "Developing custom prompts for empathetic responses.",
        },
      },
    },
    experience: {
      title: "Experience",
      subtitle: "My professional journey",
      jobs: [
        {
          period: "Sep 2024 → Oct 2024",
          company: "Ozia",
          role: "Conversational Designer",
          achievements: [
            "Chatbot creation and maintenance",
            "Generative AI implementation",
            "A/B testing on instructions",
          ],
        },
        {
          period: "Nov 2022 → Mar 2023",
          company: "Sabion ~ Bradesco",
          role: "VUX Writer",
          achievements: [
            "IVR flow curation",
            "NLP table construction",
            "Voice User Interface (VUI)",
          ],
        },
        {
          period: "Jul 2021 → Nov 2022",
          company: "Compasso UOL - TakeBlip",
          role: "UX Writer",
          achievements: [
            "Macro/micro chatbot flows",
            "Chatbot curation",
            "A/B testing",
          ],
        },
      ],
    },
    certifications: {
      title: "Certifications",
      subtitle: "Continuous learning and specialization",
      viewCertificate: "View Certificate",
    },
    projects: {
      title: "Projects",
      subtitle: "Success stories",
      detailedCases: "Detailed Cases",
      otherProjects: "Other Projects",
      viewFullCase: "View Full Case",
      legacy: {
        title: "GPT-4 in Chatbot",
        company: "Confidential Client",
        role: "Conversational Designer",
        description: "Implementation of OpenAI GPT-4 in support chatbot.",
      },
    },
    skills: {
      title: "Skills",
      subtitle: "Technical competencies",
      categories: {
        tools: "Tools",
        conversational: "Conversational Design",
        ai: "Artificial Intelligence & LLMs",
      },
      items: {
        dialogArchitecture: "Dialog Architecture",
        voiceTone: "Voice & Tone",
        promptEngineering: "Prompt Engineering",
        fineTuning: "Fine-tuning",
      },
    },
    contact: {
      title: "Contact",
      subtitle: "Let's talk",
      info: {
        email: "Email",
        phone: "Phone",
        linkedin: "LinkedIn",
      },
      form: {
        title: "Send a message",
        name: "Name",
        email: "Email",
        subject: "Subject",
        message: "Message",
        namePlaceholder: "Your name",
        emailPlaceholder: "your@email.com",
        subjectPlaceholder: "Message subject",
        messagePlaceholder: "Your message...",
        send: "Send Message",
        sending: "Sending...",
        required: "*",
      },
      validation: {
        nameRequired: "Name is required",
        nameTooLong: "Name too long",
        emailInvalid: "Invalid email",
        emailTooLong: "Email too long",
        subjectRequired: "Subject is required",
        subjectTooLong: "Subject too long",
        messageRequired: "Message must be at least 10 characters",
        messageTooLong: "Message too long",
      },
      toast: {
        validationError: "Validation error",
        validationDescription: "Please fix the errors in the form.",
        success: "Message sent!",
        successDescription: "Thank you for contacting me. I'll respond soon.",
        error: "Error sending",
        errorDescription: "Could not send your message. Please try again.",
      },
    },
    caseDetail: {
      back: "Back",
      notFound: "Case not found",
      backToHome: "Back to Home",
      viewFigma: "View on Figma",
      viewPrototype: "View Prototype",
      challenge: "The Challenge",
      solution: "My Proposal",
      responsibilities: "Responsibilities",
      tools: "Tools",
      projectEvolution: "Project Evolution",
      results: "Results",
      keyLearning: "Key Learning",
      cta: {
        title: "Liked this project?",
        description: "Let's talk about how I can help your business.",
        button: "Get in Touch",
      },
    },
    recommendations: {
      title: "Recommendations",
      subtitle: "What people say about my work",
      project: "Project"
    },
    footer: {
      name: "Paulo da Silva Pascoa Junior",
      subtitle: "UX Writer & Conversational Designer",
      rights: "All rights reserved.",
    },
  },
};
